import React, { useState, useEffect } from "react";
import { Box, Input, Button, Modal, toastEmitter, Toast, Select } from "@anchor/react-components";
import SubscriptionRuleTable from './SubscriptionRuleTable.js';
import axios from "axios";
import CONSTANTS from './SubscriptionConstants.js';
import { accessRequest } from './authConfig';
import useFetchWithMsal from './hooks/useFetchWithMsal';

function SubscriptionRule(props) {
    const { error, execute } = useFetchWithMsal(accessRequest);

    const [code1, setCode1] = useState('');
    const [code2, setCode2] = useState('');
    const [value, setValue] = useState('');
    const [linkedCode, setLinkedCode] = useState('');

    const [codeType, setCodeType] = useState([]);
    const [dropDownResposne, setDropDownResposne] = useState({});

    const [selectedDropDown1, setSelectedDropDown1] = useState('');
    const [selectedDropDown2, setSelectedDropDown2] = useState('');
    const [selectedDropDown3, setSelectedDropDown3] = useState('');

    const [dataFetched1, setDataFetched1] = useState('');
    const [dataFetched2, setDataFetched2] = useState('');
    const [dataFetched3, setDataFetched3] = useState('');

    const [counter, setCounter] = useState(0);

    const [isAuthorized, setAuthorized] = useState(true);
    const [showAuthModal, setAuthModal] = useState('');

    const containerStyle = {
        margin: "5px",
    };

    const boxStyle = {
        justifyContent: "center",
        alignItems: "center", // Center vertically
        flexDirection: "column",
        width: "100%", // Set width to 100%
        background: "#fff",
        marginBottom: "20px",
    };

    const buttonBoxStyle = {
        justifyContent: "center",
        alignItems: "center", // Center vertically
        marginTop: "20px",
        marginBottom: "20px",
        width: "100%", // Set width to 100%
    };

    const fetchDropDown = async () => {
        try {
            const urlstr = CONSTANTS.UI_BACKEND_BASE_URL + `/v1/subscriptionCode/getAllType`;
            console.log(urlstr);

            execute("GET", urlstr).then((response) => {
                if (response) {
                    if (response.status !== 401 && response.status !== 403) {
                        setCodeType(Object.keys(response));
                        setDropDownResposne(response);
                        console.log(response);
                        console.log(Object.keys(response));
                    } else {
                        setAuthModal(true);
                        setAuthorized(false);
                    }
                }
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchDropDown();
    }, [execute]);

    const handleResetButtonClick = async () => {
        setSelectedDropDown1('');
        setSelectedDropDown2('');
        setSelectedDropDown3('');
        setDataFetched1('');
        setDataFetched2('');
        setDataFetched3('');
        setCode1('');
        setCode2('');
        setValue('');
        setLinkedCode('');
        setCounter(0);
    }

    const handleFindButtonClick = async () => {
        if (!code1 && !code2 && !value && !linkedCode) {
            toastEmitter({ "title": "ALERT", "description": "Please select at least one of the Code 1, Code 2, Value or Linked Code before searching rules" }, { position: 'top-center' });
            return;
        }
        setCounter(counter + 1);
    }

    const handleCreateButtonClick = async () => {
        if (!code1 || !code2 || !value) {
            toastEmitter({ "title": "ALERT", "description": "Code 1, Code 2 and Value are mandatory fields for Rule creation" }, { position: 'top-center' });
            return;
        }

        // Construct payload using user-entered values
        const payload = {
            code1: parseInt(code1),
            code2: parseInt(code2),
            value,
            linkedCode: parseInt(linkedCode),
        };

        try {
            const urlstr = CONSTANTS.UI_BACKEND_BASE_URL + `/v1/subscriptionRule/save`;
            console.log(urlstr);

            execute("POST", urlstr, payload).then((response) => {
                if (response) {
                    if (response.status === 'OK') {
                        console.log('API call successful' + response.message);
                        toastEmitter({ "title": "SUCCESS", "description": response.message }, { position: 'top-center' })
                        setCounter(counter + 1);
                    } else {
                        if (response.status === 403) {
                            toastEmitter({ "title": "ERROR", "description": 'You are not authorized to create Subscription Rule(s).' }, { position: 'top-center', type: "error" });
                        } else {
                            toastEmitter({ "title": "ERROR", "description": response.message }, { position: 'top-center', type: "error" });
                        }
                    }
                }
            });
        } catch (error) {
            console.error('Error during API call:', error);
        }
    };

    return (
        <div style={containerStyle}>
            <Box display="grid" gridTemplateColumns="1fr 1fr" gridGap={1.5} style={buttonBoxStyle} >
                <Box p={2} borderColor="border.default" borderWidth={1}>
                    <Select
                        isClearable
                        fit="small"
                        id="selectpicker"
                        name="picknumber"
                        label="Select Code 1"
                        required
                        onChange={function noRefCheck(e) {
                            setSelectedDropDown1(e.target.value);
                            setCode1('');
                        }}
                        options={codeType}
                        orientation="vertical"
                        placeholder="Select Code"
                        variant="default"
                        value={[selectedDropDown1]}
                    />
                    <div >
                        <Select
                            fit="small"
                            id="selectpicker"
                            name="picknumber"
                            label="Select Code 1 Value"
                            required
                            disabled={selectedDropDown1 === ''}
                            onChange={function noRefCheck(e) {
                                if (selectedDropDown1 !== '') {
                                    // console.log(dropDownResposne[selectedDropDown1][e.target.value])
                                    setDataFetched1(dropDownResposne[selectedDropDown1][e.target.value])
                                    setCode1(dropDownResposne[selectedDropDown1][e.target.value])
                                }
                            }}
                            options={selectedDropDown1 !== '' ? Object.keys(dropDownResposne[selectedDropDown1]) : null}
                            orientation="vertical"
                            placeholder="Select Code Type"
                            variant="default"
                            value={[selectedDropDown1]}
                        />
                    </div>
                </Box>
                <Box p={2} borderColor="border.default" borderWidth={1}>
                    <Select
                        fit="small"
                        id="selectpicker"
                        name="picknumber"
                        label="Select Code 2"
                        required
                        onChange={function noRefCheck(e) {
                            setSelectedDropDown2(e.target.value);
                            setCode2('');
                        }}
                        options={codeType}
                        orientation="vertical"
                        placeholder="Select Code"
                        variant="default"
                        value={[selectedDropDown2]}
                    />
                    <div >
                        <Select
                            fit="small"
                            id="selectpicker"
                            name="picknumber"
                            label="Select Code 2 Value"
                            required
                            disabled={selectedDropDown2 === ''}
                            onChange={function noRefCheck(e) {
                                if (selectedDropDown2 !== '') {
                                    // console.log(e.target.value)
                                    setDataFetched2(dropDownResposne[selectedDropDown2][e.target.value])
                                    setCode2(dropDownResposne[selectedDropDown2][e.target.value])
                                }
                            }}
                            options={selectedDropDown2 !== '' ? Object.keys(dropDownResposne[selectedDropDown2]) : null}
                            orientation="vertical"
                            placeholder="Select Code Type"
                            variant="default"
                            value={[selectedDropDown2]}
                        />
                    </div>
                </Box>
                <Box p={2} borderColor="border.default" borderWidth={1}>
                    <Input
                        fit="small"
                        id="valueInput"
                        label="Value"
                        maxLength={100}
                        placeholder="Enter your value"
                        required
                        type="text"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        variant="default"
                    />
                </Box>
                <Box p={2} borderColor="border.default" borderWidth={1}>
                    <Select
                        fit="small"
                        id="selectpicker"
                        name="picknumber"
                        label="Select Linked Code"
                        onChange={function noRefCheck(e) {
                            setSelectedDropDown3(e.target.value);
                            setLinkedCode('');
                        }}
                        options={codeType}
                        orientation="vertical"
                        placeholder="Select Linked Code"
                        variant="default"
                        value={[selectedDropDown3]}
                    />
                    <div >
                        <Select
                            fit="small"
                            id="selectpicker"
                            name="picknumber"
                            label="Select Linked Code"
                            disabled={selectedDropDown3 === ''}
                            onChange={function noRefCheck(e) {
                                if (selectedDropDown3 !== '') {
                                    console.log(e.target.value)
                                    // console.log(dropDownResposne[selectedDropDown3])
                                    setDataFetched3(dropDownResposne[selectedDropDown3][e.target.value])
                                    setLinkedCode(dropDownResposne[selectedDropDown3][e.target.value])
                                }
                            }}
                            options={selectedDropDown3 !== '' ? Object.keys(dropDownResposne[selectedDropDown3]) : null}
                            orientation="vertical"
                            placeholder="Select Linked Code"
                            variant="default"
                            value={[selectedDropDown3]}
                        />
                    </div>
                </Box>
            </Box>
            <div style={boxStyle}>
                <Button
                    disabled={!isAuthorized}
                    appearance="default"
                    id="primary"
                    label="FIND"
                    width="32"
                    name="primary"
                    onClick={handleFindButtonClick}
                    title="FIND"
                    variant="filledAlt"
                    fit="small"
                />
                &nbsp;&nbsp;
                <Button
                    disabled={!isAuthorized}
                    appearance="default"
                    id="primary"
                    label="CREATE"
                    width="32"
                    name="primary"
                    onClick={handleCreateButtonClick}
                    title="CREATE"
                    variant="filledAlt"
                    fit="small"
                />
                &nbsp;&nbsp;
                <Button
                    disabled={!isAuthorized}
                    appearance="default"
                    id="primary"
                    label="RESET FIELDS"
                    width="32"
                    name="primary"
                    onClick={handleResetButtonClick}
                    title="RESET"
                    variant="filled"
                    fit="small"
                />
            </div>

            {counter !== 0 ? <SubscriptionRuleTable code1={code1} code2={code2} value={value} linkedCode={linkedCode} counter={counter} /> : ''}

            <Toast />

            <Modal
                actions={{
                    primaryAction: <Button label="Ok" onClick={function noRefCheck() { setAuthModal('') }} variant="outlined" />
                }}
                heading="Alert"
                dimension="small"
                open={showAuthModal}
                showCloseIcon
                onClose={function noRefCheck() { setAuthModal('') }}
            >
                <p>
                    You are not authorized to work on this application.
                </p>
            </Modal>
        </div>
    );
}

export default SubscriptionRule;
